const React = require('react');
const { default: InputAdornment } = require('@mui/material/InputAdornment');
const { default: Tooltip } = require('@mui/material/Tooltip');
const { default: IconButton } = require('@mui/material/IconButton');
const { default: ClearIcon } = require('@mui/icons-material/HighlightOff');
const { default: Styled } = require('styled-components');

const internals = {};

module.exports = function ClearFieldAdornment(props) {

    const {
        clearLabel = 'Clear',
        disabled = false,
        existingEndAdornment,
        onClear
    } = props;

    return <>
        {existingEndAdornment}
        <internals.ClearAdornmentSpacer
            aria-hidden='true'
            className='np-clear-field-adornment-spacer'
        />
        <internals.ClearAdornment
            className='np-clear-field-adornment'
            position='end'
            disablePointerEvents={false}
        >
            <internals.ClearSlot>
                <Tooltip arrow title='Clear' placement='top'>
                    <internals.ClearButtonHitArea>
                        <internals.ClearButton
                            aria-label={clearLabel}
                            aria-disabled={disabled}
                            $disabled={disabled}
                            onMouseDown={(event) => {
                                event.preventDefault();
                            }}
                            onClick={(event) => {
                                event.preventDefault();
                                event.stopPropagation();

                                if (disabled) {
                                    return;
                                }

                                onClear?.(event);
                            }}
                            data-focus-outline='radius:22,zIndex:1'
                        >
                            <internals.ClearSvg />
                        </internals.ClearButton>
                    </internals.ClearButtonHitArea>
                </Tooltip>
            </internals.ClearSlot>
        </internals.ClearAdornment>
    </>;
};

internals.ClearAdornmentSpacer = Styled.span`
    display: inline-flex;
    flex: 0 0 36px;
    width: 36px;
    min-width: 36px;
    height: 1px;
    min-height: 1px;
    line-height: 0;
    pointer-events: none;
`;

internals.ClearAdornment = Styled(InputAdornment)`
    && {
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
        display: inline-flex;
        align-items: center;
        justify-content: center;
        align-self: auto;
        flex: 0 0 36px;
        width: 36px;
        min-width: 36px;
        max-width: 36px;
        height: 36px;
        min-height: 36px;
        max-height: 36px;
        margin: 0 !important;
        line-height: 0;
        pointer-events: auto;
        z-index: 1;
    }
`;

internals.ClearSlot = Styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 36px;
    width: 36px;
    min-width: 36px;
    height: 36px;
    min-height: 36px;
    line-height: 0;
`;

internals.ClearButtonHitArea = Styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 34px;
    width: 34px;
    min-width: 34px;
    height: 34px;
    min-height: 34px;
    line-height: 0;
`;

internals.ClearButton = Styled(IconButton)`
    && {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        flex: 0 0 34px;
        width: 34px;
        min-width: 34px;
        height: 34px;
        min-height: 34px;
        padding: 4px;
        line-height: 0;
        color: ${({ theme }) => theme.palette.text?.secondary || 'rgba(0, 0, 0, 0.54)'};
        opacity: 1;
        pointer-events: auto;
        cursor: ${({ $disabled }) => $disabled ? 'default' : 'pointer'};
        transition: color 120ms ease-in-out, background-color 120ms ease-in-out;
    }

    &&:hover {
        color: ${({ theme, $disabled }) => $disabled
        ? (theme.palette.text?.secondary || 'rgba(0, 0, 0, 0.54)')
        : (theme.palette.primary?.main || '#4c37b5')};
        background-color: ${({ $disabled }) => $disabled ? 'transparent' : 'rgba(76, 55, 181, 0.08)'};
    }

    &&.Mui-disabled,
    &&[aria-disabled='true'] {
        color: ${({ theme }) => theme.palette.text?.secondary || 'rgba(0, 0, 0, 0.54)'};
        opacity: 1;
        pointer-events: auto;
    }
`;

internals.ClearSvg = Styled(ClearIcon)`
    && {
        flex: 0 0 20px;
        width: 20px !important;
        min-width: 20px !important;
        height: 20px !important;
        min-height: 20px !important;
        font-size: 20px !important;
    }
`;

module.exports.internals = internals;
